import { Link } from 'react-router-dom';

export interface BrandProps {
  logoSrc: string;
  logoAlt: string;
  /** desktop = h-20, mobile = h-14 (tamaño original del header) */
  size?: 'desktop' | 'mobile';
}

/**
 * Brand: logo en header. size=desktop h-20, size=mobile h-14.
 */
export function Brand({ logoSrc, logoAlt, size = 'desktop' }: BrandProps) {
  const imgClass = size === 'mobile' ? 'h-14' : 'h-20';
  return (
    <Link
      to="/"
      className="flex items-center flex-shrink-0 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-[#fbf8f5] rounded"
      aria-label="Go to homepage"
    >
      <img
        src={logoSrc}
        alt={logoAlt}
        className={`${imgClass} w-auto cursor-pointer hover:opacity-80 transition-opacity object-contain`}
        loading="eager"
      />
    </Link>
  );
}
